import React, { useEffect, ChangeEvent, useState, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../Redux/app/hooks";
import { postBulkTradeUpload } from "../../Redux/features/Dashboard/DashBoardSlice";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { useOnClickOutside } from "../../CustomHooks/useOnClickOutside";
import loaderGIF from "../../assets/loader.gif";
import themesConfig from "../../utils/themesConfig";
import CustomDatePicker from "../CustomDatePicker/CustomDatePicker";
import { Link } from "react-router-dom";
const baseURL: any = themesConfig.get_react_app_login_url();
type Props = {};
const UploadButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const [show, setShow] = useState(false);
  //   const [loading, setLoading] = useState(false);
  const [startDate, setDate] = useState(new Date());
  const [rangeStart, setRangeStart] = React.useState(new Date());
  const defaultEndDate = new Date();
  defaultEndDate.setDate(defaultEndDate.getDate() + 7);
  const [rangeEnd, setRangeEnd] = React.useState(defaultEndDate);
  const today = new Date();
  const selectDateHandler = (d: any) => {
    setDate(d);
  };
  const [File, setFile] = useState<any>(null);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const handleFileChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setSelectedFile(file.name);
      setFile(file);
    }
  };

  const loading = useAppSelector((state) => state.dashBoard.bulkUploadStatus);
  // console.log("selectedFile", selectedFile);
  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("bulk_trades", File ? File : "");
    dispatch(postBulkTradeUpload(formData)).then((res: any) => {
      if (res.payload.status === 1) {
        toast.success(
          <>
            <p className="font-weight">{res.payload.message}</p>
          </>,
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
          }
        );
        setShow(false);
        // setLoading(false);
        setTimeout(() => {
          window.location.href = res.payload.data.url;
        }, 2000);
      } else {
        toast.error(
          <>
            <p className="font-weight">{res.payload.message}</p>
          </>,
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
          }
        );
      }
    });
    setSelectedFile("");
    setFile(null);
    // setLoading(false);
  };

  const ref: any = useRef(null);
  useOnClickOutside(ref, () => setShow(false));

  return (
    <div id="fourth-element" className={`${show === true ? "open" : ""} upload-btn current-design-btn ml-10`} ref={ref}>
      <button className="dropdown-toggle new-btn-2" type="button" data-toggle="dropdown" onClick={() => setShow((show) => !show)}>
        <span className="new-btn-2-span">
          {/* <svg className="updown-arrow" xmlns="http://www.w3.org/2000/svg" width="28.121" height="16.121" viewBox="0 0 28.121 16.121">
            <g id="arrow_blue" data-name="arrow blue" transform="translate(-349.939 -4170.939)">
              <line
                id="innerColorStro"
                data-name="Line 5"
                x2="6"
                y2="6"
                transform="translate(351 4180)"
                fill="none"
                strokeLinecap="round"
                strokeWidth="1.5"
              />
              <line
                id="innerColorStro"
                data-name="Line 7"
                y1="6"
                x2="6"
                transform="translate(365 4172)"
                fill="none"
                strokeLinecap="round"
                strokeWidth="1.5"
              />
              <line
                id="innerColorStro"
                data-name="Line 6"
                x1="6"
                y2="6"
                transform="translate(357 4180)"
                fill="none"
                strokeLinecap="round"
                strokeWidth="1.5"
              />
              <line
                id="innerColorStro"
                data-name="Line 8"
                x1="6"
                y1="6"
                transform="translate(371 4172)"
                fill="none"
                strokeLinecap="round"
                strokeWidth="1.5"
              />
              <path
                id="innerColorStro"
                data-name="Path 136"
                d="M455.433,4163v14"
                transform="translate(-98.433 9)"
                fill="none"
                strokeLinecap="round"
                strokeWidth="1.5"
              />
              <path
                id="innerColorStro"
                data-name="Path 137"
                d="M455.433,4177v-14"
                transform="translate(-84.433 9)"
                fill="none"
                strokeLinecap="round"
                strokeWidth="1.5"
              />
            </g>
          </svg> */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
            <path
              // fill="#071932"
              className="innerColor"
              id="portfolio_blue"
              d="M171.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4 144 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm352-342.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 86.6 432 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-377.4-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96z"
            />
          </svg>
        </span>
        <div className="tooltiptext tool-right">
          <p>Upload/Download</p>
        </div>
      </button>
      {show && (
        <ul className="dropdown-menu pull-right sm-wh-100">
          {/* <div className="form-body">
              <div className="uploadBox">               
                <div className="formGroup">
                  <div className="input-container">
                    <label className="control-label title-label">
                      Upload<span className="required">*</span>
                    </label>
                    <input type="file" className="form-control file-input" onChange={handleFileChange} />
                  </div>
                </div>
                <a href={`${baseURL}file/BulkUploadTemplate.csv`} className="upload-link ml-10">
                  Download Template
                </a>
                <button
                  className="form-control upload-submit"
                  type="submit"
                  disabled={loading === "loading"}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  {loading === "loading" ? (
                    <>
                      <img className="uploadLoader" src={loaderGIF} alt="loading" />
                    </>
                  ) : (
                    "Upload File"
                  )}
                </button>
              </div>
            </div> */}

          {/* new design */}
          <div className="form-body">
            <div className="upload-group">
              {/* <div className="form-group ffl-wrapper mb-0">
                        <label className="control-label ffl-label">Uploaded Date<span className="required">*</span></label>
                        {!! Form::text('uploaded_date',null, ['class' => 'form-control upload_date', 'data-required' => true]) !!}
                    </div> */}
              <div className="formGroup">
                <CustomDatePicker startDate={startDate} selectDateHandler={selectDateHandler} today={today} label={"Uploaded Date"} />
              </div>
              <div className="form-group file_upload">
                <div className="file file--upload">
                  <label htmlFor="excelToUpload" id="uploadFileLbl">
                    <svg className="uploadFileLbl" xmlns="http://www.w3.org/2000/svg" width="29.649" height="29.649" viewBox="0 0 29.649 29.649">
                      <g transform="translate(13.788) rotate(41)">
                        <path
                          className="innerColorSto"
                          d="M8.319,4.378v10.07a3.5,3.5,0,0,1-7.005,0V3.5a2.189,2.189,0,1,1,4.378,0V12.7a.876.876,0,1,1-1.751,0V4.378H2.627V12.7a2.189,2.189,0,1,0,4.378,0V3.5A3.5,3.5,0,1,0,0,3.5V14.449a4.816,4.816,0,1,0,9.633,0V4.378Z"
                          transform="translate(6.13 0.876)"
                        />
                        <path className="noFill" d="M0,0H21.016V21.016H0Z" transform="translate(0 0)" />
                      </g>
                    </svg>
                    <div className="tooltiptext tool-right">
                      <p>Attach File</p>
                    </div>
                  </label>
                  <input type="file" id="excelToUpload" className="form-control file-input" onChange={handleFileChange} />
                </div>
              </div>
              <div className="p-relative current-design-btn">
                <button
                  className="form-control upload-submit new-btn-2"
                  type="submit"
                  disabled={loading === "loading"}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  <span className="new-btn-2-span">
                    {loading === "loading" ? (
                      <>
                        <img className="uploadLoader" src={loaderGIF} alt="loading" />
                      </>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="14.121" height="15.811" viewBox="0 0 14.121 15.811">
                        <g id="upload-arrow-grey" transform="translate(-951.939 -1486.939)">
                          <line
                            id="innerColorStro"
                            className="innerColorStro"
                            y1="6"
                            x2="6"
                            transform="translate(953 1488)"
                            fill="none"
                            strokeLinecap="round"
                            strokeWidth="1.5"
                          />
                          <line
                            id="innerColorStro"
                            className="innerColorStro"
                            x1="6"
                            y1="6"
                            transform="translate(959 1488)"
                            fill="none"
                            strokeLinecap="round"
                            strokeWidth="1.5"
                          />
                          <path
                            id="innerColorStro"
                            className="innerColorStro"
                            d="M455.433,4177v-14"
                            transform="translate(503.567 -2675)"
                            fill="none"
                            strokeLinecap="round"
                            strokeWidth="1.5"
                          />
                        </g>
                      </svg>
                    )}
                  </span>
                  <div className="tooltiptext tool-right">
                    <p>Upload</p>
                  </div>
                </button>
              </div>
            </div>
            {selectedFile && <span className="upload-file-name">File name: {selectedFile}</span>}
            {/* <span className="upload-file-name" id="file-upload-filename">File name: PROMPT OIL EXPORT.pdf</span> */}
          </div>
          {/* <div className="form-body">
                <a href={`${baseURL}uploaded-bank-statements`} className="upload-link mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                    <path id="innerColor" d="M.294,14.829A4.586,4.586,0,0,1,1.441,9.865c.875-.905,1.777-1.784,2.666-2.674a4.342,4.342,0,0,1,.516-.449c.035-.025.073-.085.117-.05.026.021.024.085.021.129-.01.2-.032.409-.037.614a5.352,5.352,0,0,0,.232,1.714.213.213,0,0,1-.066.245c-.681.677-1.369,1.348-2.034,2.04a2.633,2.633,0,0,0,3.607,3.829q.107-.091.206-.191Q8,13.736,9.339,12.4a2.634,2.634,0,0,0,.055-3.766,1.582,1.582,0,0,1,.045-2.306A.187.187,0,0,1,9.7,6.282,4.651,4.651,0,0,1,12.134,9.4a4.519,4.519,0,0,1,.123,1.063,4.8,4.8,0,0,1-1.4,3.4Q9.5,15.244,8.123,16.6A4.791,4.791,0,0,1,4.742,18,4.659,4.659,0,0,1,.294,14.829Zm10.394,2.455c-.1-.336-.193-.674-.273-1.014a.518.518,0,0,1,.5-.662.511.511,0,0,1,.5.364c.1.347.2.7.282,1.048a.521.521,0,0,1-.379.638.536.536,0,0,1-.141.019A.518.518,0,0,1,10.688,17.284Zm3.945-1.922c-.278-.259-.542-.532-.806-.805a.443.443,0,0,1-.12-.339.494.494,0,0,1,.285-.466.476.476,0,0,1,.558.056c.288.264.567.541.831.83a.508.508,0,0,1-.035.7.531.531,0,0,1-.375.157A.492.492,0,0,1,14.633,15.362ZM8.347,11.733a4.661,4.661,0,0,1-2.5-3.368,4.479,4.479,0,0,1,.137-2.254A4.893,4.893,0,0,1,7.191,4.1c.9-.895,1.8-1.8,2.695-2.7A4.751,4.751,0,0,1,12.627.039a.164.164,0,0,1,.03,0c.03,0,.06,0,.074-.039h.984c.01.039.042.031.07.034a4.723,4.723,0,0,1,4.038,3.429c.069.261.119.527.178.791v1.02a5.568,5.568,0,0,0-.151.672,4.8,4.8,0,0,1-1.255,2.177q-1.353,1.354-2.707,2.708a3.589,3.589,0,0,1-.644.526c.021-.3.053-.569.056-.84a5.619,5.619,0,0,0-.228-1.663.223.223,0,0,1,.067-.259c.661-.655,1.323-1.311,1.974-1.975a2.637,2.637,0,0,0-.5-4.138,2.61,2.61,0,0,0-3.173.363q-1.431,1.4-2.83,2.834a2.616,2.616,0,0,0-.02,3.636A1.592,1.592,0,0,1,8.553,11.7a.17.17,0,0,1-.117.064A.192.192,0,0,1,8.347,11.733Zm8.695-.038c-.352-.084-.7-.179-1.049-.281a.526.526,0,0,1-.365-.633.52.52,0,0,1,.635-.381q.519.127,1.032.275a.514.514,0,0,1,.389.5.526.526,0,0,1-.522.531A.517.517,0,0,1,17.041,11.695ZM1.773,7.595c-.364-.082-.725-.18-1.082-.288a.52.52,0,0,1-.348-.582.536.536,0,0,1,.551-.436.815.815,0,0,1,.123.018c.333.088.666.174,1,.269a.53.53,0,0,1,.381.64.515.515,0,0,1-.5.393A.549.549,0,0,1,1.773,7.595ZM3.41,4.136c-.245-.243-.492-.484-.73-.733a.526.526,0,1,1,.744-.743q.379.365.743.745a.5.5,0,0,1,.1.583.5.5,0,0,1-.484.31H3.779A.512.512,0,0,1,3.41,4.136ZM7.1,2.39A.525.525,0,0,1,6.593,2Q6.446,1.487,6.317.968A.522.522,0,0,1,6.685.337a.511.511,0,0,1,.639.344c.108.358.206.719.29,1.083A.522.522,0,0,1,7.1,2.39Z" transform="translate(0)"/>
                    </svg> Uploaded Files</a>
            </div> */}
          <div className="form-body">
            <a href={`${baseURL}file/TradeEntryTemplate.csv`} className="download-link mb-00">
              <svg xmlns="http://www.w3.org/2000/svg" width="14.121" height="15.811" viewBox="0 0 14.121 15.811">
                <g id="download-arrow-grey" transform="translate(-349.939 -4171.25)">
                  <line
                    id="innerColorStro"
                    className="innerColorStro"
                    data-name="Line 5"
                    x2="6"
                    y2="6"
                    transform="translate(351 4180)"
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                  <line
                    id="innerColorStro"
                    className="innerColorStro"
                    data-name="Line 6"
                    x1="6"
                    y2="6"
                    transform="translate(357 4180)"
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                  <path
                    id="innerColorStro"
                    className="innerColorStro"
                    data-name="Path 136"
                    d="M455.433,4163v14"
                    transform="translate(-98.433 9)"
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                </g>
              </svg>
              Trade Entry Template
            </a>
          </div>
          {/* <div className="form-body">
            <a href="#" className="download-link mb-00">
              <svg xmlns="http://www.w3.org/2000/svg" width="14.121" height="15.811" viewBox="0 0 14.121 15.811">
                <g id="download-arrow-grey" transform="translate(-349.939 -4171.25)">
                  <line
                    id="innerColorStro"
                    className="innerColorStro"
                    data-name="Line 5"
                    x2="6"
                    y2="6"
                    transform="translate(351 4180)"
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                  <line
                    id="innerColorStro"
                    className="innerColorStro"
                    data-name="Line 6"
                    x1="6"
                    y2="6"
                    transform="translate(357 4180)"
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                  <path
                    id="innerColorStro"
                    className="innerColorStro"
                    data-name="Path 136"
                    d="M455.433,4163v14"
                    transform="translate(-98.433 9)"
                    fill="none"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                  />
                </g>
              </svg>
              Portfolio Numbers
            </a>
          </div> */}
        </ul>
      )}
    </div>
  );
};

export default UploadButton;
